module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen3@2x-4167105097b5bdabf7bb76016df40d40.png";